// extracted by mini-css-extract-plugin
export default {"minimizedDetail":"TGrH4","title":"Mzvw7","compactAutoplayUiMode":"ERYbl","prompt":"RapWZ","counter":"k7TYq"};